import React from "react";
import {observer, inject} from "mobx-react";
import {observable, computed} from 'mobx';
import {withRouter, Route, Link, Switch} from "react-router-dom";
import PurchaseOrderList from './PurchaseOrderList';
import SpreadsheetImport from '../Import/SpreadsheetImport';
import {components} from 'react-select';
import Select, {Async as AsyncSelect} from 'react-select';
import debounce from '@utils/debounce';
import {ToolbarDropdown, ToolbarSection} from "@components/Toolbar/ToolbarDropdown"
import Spinner from "@utils/spinner";
import getBoxPadUrl from "@utils/getBoxPadUrl"
import axios from "axios";
import PurchaseOrderAdd from "./PurchaseOrderAdd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Modal from "@components/react-responsive-modal/modal";

const SingleValue = ({children, ...props}) => (
    <components.SingleValue {...props}>
        {props.data.CompanyName}, {props.data.City}, {props.data.CountryName}
    </components.SingleValue>
);

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <FontAwesomeIcon icon={["fas", "angle-down"]}/>
            </components.DropdownIndicator>
        )
    );
};

const customStyles = {

    container: (provided, state) => ({
        ...provided,
        position: ""

    }),

    control: (provided, state) => ({
        ...provided,
        background: '#fff',
        borderColor: '#9e9e9e',
        minHeight: '30px',
        height: '30px',
        boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
        ...provided,
        height: '30px',
        padding: '0 6px'
    }),

    input: (provided, state) => ({
        ...provided,
        margin: '0px',
    }),

    menu: (provided, state) => ({
        ...provided,
        marginTop: '0px',
        width: "100%"
    }),
    indicatorSeparator: state => ({
        display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '30px',
    }),
};

@inject("store")
@observer
class PurchaseOrderView extends React.Component {
    @observable SelectedCustomerId = "";
    @observable SelectedAddress = "";
    @observable footerExpanded = false;
    @observable headerExpanded = false;
    @observable addProduct = null;
    @observable processingCheckout = false;

    constructor(props) {
        super(props);
        this.formatAddress = this.formatAddress.bind(this);
        this.toggleExpandedFooter = this.toggleExpandedFooter.bind(this);
        this.toggleExpandedHeader = this.toggleExpandedHeader.bind(this);
        this.searchProduct = this.searchProduct.bind(this);
        this.openProduct = this.openProduct.bind(this);
        this.checkout = this.checkout.bind(this);

        this.addProductSelect = null;

        this.addProductRef = element => {
            this.addProductSelect = element;
        };

        this.onOpenGlassInfoModal = this.onOpenGlassInfoModal.bind(this);
        this.onCloseGlassInfoModal = this.onCloseGlassInfoModal.bind(this);
        this.glassModalRef = React.createRef();

        this.state = {
            glassInfoModal: false
        }

    }


    asyncSelectHandleKeyDown(evt) {
        switch (evt.key) {
            case "Home":
                evt.preventDefault();
                if (evt.shiftKey) evt.target.selectionStart = 0;
                else evt.target.setSelectionRange(0, 0);
                break;
            case "End":

                evt.preventDefault();
                var len = evt.target.value.length;
                if (evt.shiftKey) evt.target.selectionEnd = len;
                else evt.target.setSelectionRange(len, len);
                break;
        }

    }


    formatAddress(address) {
        return (<div><strong>{address.CompanyName}</strong><br/>{address.Line1}<br/>{address.Line2}<br/>{address.PostalCode} {address.City} <br/>{address.CountryName}</div>);
    }

    toggleExpandedHeader() {
        this.headerExpanded = !this.headerExpanded;
    }

    toggleExpandedFooter() {
        this.footerExpanded = !this.footerExpanded;
    }

    toggleImport() {
        this.importData = {};
        this.importVisible = !this.importVisible;
    }


    async searchProduct(input) {
        const navigation = this.props.store.navigation;
        const url = this.props.store.navigation.mainTree.SearchUrl;

        const query = "q=" + input;

        const res = await this.request("/Umbraco/Api/Content/Getnode?url=" + url + "&" + query, //self.currentUrl,
            {
                Url: url,
                CustomerId: navigation.UrlCustomerId,
                MarketCode: navigation.MarketCode,
                CultureCode: navigation.CultureCode,
                ProductsFrom: 0
            });

        return res;

        //const products = (res.Products && res.Products.length > 10) ? res.Products.slice(0, 10) : res.Products;
        //return products;

    }

    async request(path, query = {}) {
        const res = await axios.post(`${path}`, query);
        return res.data;
    }


    //async searchProduct(input) {
    //    const searchStore = this.props.store.search;
    //    const result = await searchStore.searchProducts(input);

    //    return result;
    //}

    formatProduct(product) {
        const navigation = this.props.store.navigation;
        const brand = product && product.Properties && product.Properties.f_Brand;
        const brandName = (brand && Array.isArray(brand) && brand.length > 0)
            ? brand[0]
            : null;

        const stockStatus = product && product.Properties && product.Properties.StockStatus;
        let stockInfo = "";
        switch (stockStatus) {
            case "PreBook":
                stockInfo = "*Förboka*";
                break;
        }

        return (<div className={"d-flex text-xs"}>
            <div style={{flex: "0 0 40px"}}>
                {product.PrimaryImageUrl !== ""
                    ? <img src={getBoxPadUrl(product.PrimaryImageUrl, 40, 40, "webp", "ffffff").url} style={{width: 40, float: "left", marginRight: 7}}/>
                    : <img src="/dist/img/no_image.jpg" style={{width: 40, float: "left", marginRight: 7}}/>
                }
            </div>
            <div className={""} style={{flex: "1", marginLeft: 10}}><strong><span className="text-xxs">{brandName}</span></strong><br/>{product.Name} {stockInfo}</div>
        </div>);
    }

    openProduct(product) {
        if (product && (product.VariantSku || product.Sku)) {
            const navigation = this.props.store.navigation;
            //navigation.openProductDialog(product.Sku);
            const orderStore = this.props.store.order;
            const changes =
                [
                    {
                        Sku: product.Sku,
                        VariantSku: product.VariantSku,
                        AddQuantity: 1
                        //ProductUrl: this.state.productUrl,
                        //ProductImage: this.state.productImage
                    }
                ];

            orderStore.increaseQuantities(changes);
        }
    }


    checkout() {
        const orderStore = this.props.store.order;

        this.processingCheckout = true;
        orderStore.activeOrder.checkout().then(
            result => {
                this.processingCheckout = false;
            },
            error => {
                alert(error.message);
                this.processingCheckout = false;
            });
    }

    async checkIsValidSku(data, column, checks) {
        let result = 0;
        for (var c = 0; c < checks; c++) {
            const checkRowIndex = Math.floor(Math.random() * (data.rows.length - (data.hasHeaders ? 1 : 0))) + (data.hasHeaders ? 1 : 0);
            const perhapsASku = this.importData.rows[checkRowIndex][column.index];

            var res = await this.props.store.order.getProduct(perhapsASku); //.then(res => {

            if (res && res.product) {
                // This is a valid sku
                result++;
            }
            //});
        }

        return (result / checks) > 0.2;

    }

    onOpenGlassInfoModal() {
        this.setState({glassInfoModal: true});
    }

    onCloseGlassInfoModal() {
        this.setState({glassInfoModal: false});
    }


    render() {
        const {store} = this.props;
        const orderStore = store.order;
        const accountStore = store.account;
        const navigationStore = store.navigation;

        const headerClasses = [
            "purchaseorder-header",
            "basket",
            this.headerExpanded ? "expanded" : null
        ];

        const footerClasses = [
            "purchaseorder-footer",
            this.footerExpanded ? "expanded" : null
        ];

        const parentMatch = this.props.match;
        {/*<ToolbarDropdown key={"order"} match={parentMatch}> */
        }


        const orderOptions = orderStore.Orders.map(order => {
            return {
                value: order.OrderGuid,
                label: "Order: " + order.OrderNumber + " " + (order.Reference ? " - (" + order.Reference + ")" : "") + " - Önskad leverans: " + order.DeliveryDate
            }
        });

        const selectedOrderOption = orderStore.activeOrder != null && orderOptions.find(x => x.value === orderStore.activeOrder.OrderGuid);

        const glassLines = (orderStore.activeOrder && orderStore.activeOrder.ProductList.flatMap(pl => pl.OrderLines.flatMap(ol => ol)).filter(line => line.Properties.some(p => p.Key === '_glassitem' && p.Value === 'True'))) || [];
        
        
        return (
            !orderStore.activeOrder
                ? <PurchaseOrderAdd hideHeader={false}
                                    closeOnOverlayClick={navigationStore.isMobile}
                />
                : <ToolbarDropdown
                    navigation={this.props.store.navigation}
                    key={"order"} match={parentMatch} header={this.props.store.navigation.dictionary.Cart} {...this.props}>

                    <ToolbarSection>
                        <div className="purchaseorder">
                            <div className="purchaseorder-inner">
                                {navigationStore.CustomerRoleIsReadOnly
                                    ? <div className="read-only-product-edit-header"></div>
                                    : <div className={headerClasses.join(' ')}>
                                        <div className="purchaseorder-toolbar">
                                            <div className="pr-1" style={{flex: "1 1"}}>
                                                <div className="form-group mb-3">
                                                    <Select
                                                        // components={{DropdownIndicator}}
                                                        //onKeyDown={this.asyncSelectHandleKeyDown}
                                                        className={"purchaseorder-select ignore-scroll-lock"}
                                                        // getOptionLabel={(product) => {
                                                        //     return this.formatProduct(product)
                                                        // }}

                                                        styles={customStyles}
                                                        value={selectedOrderOption}
                                                        options={orderOptions}
                                                        isClearable={false}
                                                        isSearchable={false}
                                                        onChange={(order) => {
                                                            orderStore.getOrder(order.value, true)
                                                        }}
                                                    />

                                                    {/*<select*/}
                                                    {/*    className="form-control form-control-sm"*/}
                                                    {/*    value={orderStore.activeOrder ? orderStore.activeOrder.OrderGuid : ""}*/}
                                                    {/*    onChange={(e) => {*/}
                                                    {/*        orderStore.getOrder(e.target.value, true)*/}
                                                    {/*    }}>*/}
                                                    {/*    {orderStore.Orders.map(order => (*/}
                                                    {/*        <option key={order.OrderGuid} value={order.OrderGuid}>{order.OrderNumber} {*/}
                                                    {/*            order.Reference ? ` - (${order.Reference})` : ""} {` - Önskad leverans: ${order.DeliveryDate}`}</option>*/}
                                                    {/*    ))}*/}
                                                    {/*</select>*/}
                                                </div>

                                            </div>

                                            <div style={{flex: "0 0 104px"}}>
                                                <button
                                                    className="btn btn-light btn-sm  my-0 ml-1 mr-0"
                                                    style={{height: 30, width: 30, padding: "0px 0px",}}
                                                    onClick={(e) => {
                                                        this.props.store.navigation.openOrderAdd(false);
                                                    }}><i className="material-icons add"></i></button>

                                                <button
                                                    disabled={!orderStore.activeOrder}
                                                    className="btn btn-light my-0 ml-1 mr-0"
                                                    style={{height: 30, width: 30, padding: "0px 0px"}}
                                                    onClick={(e) => {
                                                        this.props.store.navigation.openOrderSettings();
                                                    }}><i className="material-icons edit"></i></button>

                                                <button
                                                    disabled={!orderStore.activeOrder}
                                                    className="btn btn-light border-p  my-0 ml-1 mr-0"
                                                    style={{height: 30, width: 30, padding: "0px 0px"}}
                                                    onClick={(e) => {
                                                        if (confirm("Are you sure that you want to delete order: " +
                                                            orderStore.activeOrder.OrderNumber)) {
                                                            orderStore.deleteOrder(null, orderStore.activeOrder.OrderGuid).then(
                                                                success => {
                                                                },
                                                                error => {
                                                                    alert(error.message)
                                                                });
                                                        }
                                                    }}><i className="material-icons delete"></i></button>
                                            </div>

                                        </div>

                                        <div className="purchaseorder-addarticles">
                                            <div className="" style={{flex: "1 1", paddingRight: "0.25rem"}}>
                                                <AsyncSelect
                                                    styles={customStyles}
                                                    // components={{DropdownIndicator}}
                                                    onKeyDown={this.asyncSelectHandleKeyDown}
                                                    className={"ignore-scroll-lock"}
                                                    isDisabled={orderStore.activeOrder &&
                                                        orderStore.activeOrder.Readonly}
                                                    getOptionLabel={(product) => {
                                                        return this.formatProduct(product)
                                                    }}
                                                    value={this.addProduct}
                                                    loadOptions={debounce((input, callback) => {
                                                            this.searchProduct(input).then(result =>
                                                                callback(result.Products)).catch(err => callback([]));
                                                        },
                                                        400)}
                                                    noOptionsMessage={() =>
                                                        "Skriv ett produktnamn eller artikelnummer för att söka..."}
                                                    placeholder={!orderStore.activeOrder ||
                                                    (orderStore.activeOrder && orderStore.activeOrder.Readonly)
                                                        ? "Vänligen välj en order"
                                                        : "Lägg till artikel..."}
                                                    isClearable={true}
                                                    onChange={(product) => {
                                                        this.openProduct(product);
                                                    }}
                                                />
                                            </div>
                                            <div className="" style={{flex: "0 0 104px", paddingLeft: "0.25rem"}}>
                                                <div className="form-group mb-0" style={{position: "relative"}}>
                                                    <SpreadsheetImport/>
                                                </div>
                                            </div>
                                        </div>
                                        {orderStore.activeOrder &&
                                            <React.Fragment>
                                                {orderStore.activeOrder.CheckoutStarted
                                                && orderStore.activeOrder.CheckoutUser !== accountStore.UserId
                                                    ? <React.Fragment>
                                                        <div className="row mb-0">
                                                            <div className="col-12">
                                                                <div className="iziToast iziToast-warning" style={{display: "block"}
                                                                }>
                                                                    <div className="iziToast-body" style={{paddingLeft: 33}
                                                                    }><p><i className="iziToast-icon material-icons warning mr-3"></i>
                                                                        <span>Denna order är låst av en annan användare som påbörjat utcheckning.</span>
                                                                        {/*{orderStore.activeOrder &&*/}
                                                                        {/*orderStore.activeOrder.CheckoutStarted &&*/}
                                                                        {/*orderStore.activeOrder.CheckoutUser !== accountStore.UserId*/}
                                                                        {/*    &&*/}
                                                                        {/*    // ? <span>Denna order är låst av <strong>dig</strong> för utcheckning.</span>*/}
                                                                        {/*}*/}
                                                                    </p>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                    : null
                                                }
                                            </React.Fragment>
                                        }

                                    </div>
                                }

                                <div className="d-flex purchaseorder-content-header ">
                                    <div className="image"></div>
                                    <div className="name">Artikel</div>
                                    <div className="price">À Pris</div>
                                    <div className="quantity">Antal</div>
                                </div>

                                {orderStore.activeOrder && <PurchaseOrderList order={orderStore.activeOrder}/>}

                                {navigationStore.CustomerRoleIsReadOnly
                                    ? null
                                    : orderStore.activeOrder &&
                                    <div className={footerClasses.join(' ')}>
                                        <div className={"cart-inner"}>
                                            <div className={"cart-footer"}>

                                                <dl className="cart-order-totals">
                                                    <dt className="">{this.props.store.navigation.dictionary.SubTotalExTax || "Subtotal"}
                                                    </dt>

                                                    <dd>
                                                        {orderStore.activeOrder.Updating
                                                            ? <Spinner/>
                                                            : <strong>
                                                                {orderStore.activeOrder.SubTotalFormatted + " " + orderStore.activeOrder.Currency}</strong>}
                                                    </dd>

                                                    <dt>
                                                        {this.props.store.navigation.dictionary.Shipping}
                                                    </dt>
                                                    <dd>{orderStore.activeOrder.Updating
                                                        ? <Spinner/>
                                                        : <React.Fragment>
                                                            {/*{(glassLines !== null && glassLines.length > 0 && orderStore.activeOrder.ShippingTotal > 0)*/}
                                                            {(orderStore.activeOrder.ShippingTotal > 0)
                                                                ? <React.Fragment>
                                                                    <a
                                                                        onClick={this.onOpenGlassInfoModal}
                                                                        className="material-icons info_outline glass-info"></a>
                                                                    <Modal

                                                                        blockScroll={false}
                                                                        classNames={{
                                                                            overlay: "basket-overlay",
                                                                            modal: "basket-modal"
                                                                            // closeIcon: "product-dialog-closeIcon"
                                                                        }}
                                                                        open={this.state.glassInfoModal} onClose={this.onCloseGlassInfoModal}

                                                                    >
                                                                        <div
                                                                            onClick={(e) =>
                                                                            {
                                                                                this.props.store.navigation.aHrefNavigation(e);
                                                                                this.props.store.navigation.closeToolbar();
                                                                                
                                                                            }}
                                                                            dangerouslySetInnerHTML={{ __html: this.props.store.navigation.dictionary.GlassItems }}></div>
                                                                        
                                                                        
                                                                        
                                                                    </Modal>
                                                                </React.Fragment>
                                                                :null

                                                            }
                                                            <strong>{orderStore.activeOrder.ShippingTotalExTaxFormatted + " " + orderStore.activeOrder.Currency}</strong>

                                                        </React.Fragment>
                                                    }
                                                    </dd>
                                                    <dt>

                                                    </dt>
                                                    <dd>{orderStore.activeOrder.Updating
                                                        ? <Spinner/>
                                                        : <span
                                                            className={"free-shipping-info " + (parseFloat(orderStore.activeOrder.FreeShippingInfo) > 0 ? "left" : "free")}>{parseFloat(orderStore.activeOrder.FreeShippingInfo) > 0 ? this.props.store.navigation.dictionary.FreeShippingInfo.replace("{0}", orderStore.activeOrder.FreeShippingInfo) : this.props.store.navigation.dictionary.FreeShipping}</span>
                                                    }
                                                    </dd>


                                                    <dt className="cart-sum-total">{this.props.store.navigation.dictionary.TotalInclTax}</dt>
                                                    <dd className="cart-sum-total">
                                                        <strong>{orderStore.activeOrder.OrderTotalFormatted === "0.00" || orderStore.activeOrder.OrderTotalFormatted === "0,00" ? 0 : orderStore.activeOrder.OrderTotalFormatted} {orderStore.activeOrder.Currency}</strong>
                                                        <br/><span
                                                        className="vat-info">{this.props.store.navigation.dictionary.VatTotal} {orderStore.activeOrder.TaxTotal > 0 ? orderStore.activeOrder.TaxTotalFormatted : 0} {orderStore.activeOrder.Currency}</span>
                                                    </dd>


                                                </dl>

                                                <div className="basket-cta-container mt-2">
                                                    <button
                                                        disabled={(orderStore.activeOrder &&
                                                                orderStore.activeOrder.CheckoutStarted &&
                                                                orderStore.activeOrder.CheckoutUser !==
                                                                accountStore.UserId) ||
                                                            !orderStore.activeOrder.Valid ||
                                                            this.processingCheckout}
                                                        onClick={() => {
                                                            this.props.store.navigation.openCheckout();
                                                            // orderStore.activeOrder.checkoutStart().then(
                                                            //     (success) => {
                                                            //        
                                                            //     });

                                                        }}
                                                        className="product-button-purchase"
                                                    >


                                                        {orderStore.activeOrder.CheckoutStarted
                                                            ? orderStore.activeOrder.CheckoutUser ===
                                                            accountStore.UserId
                                                                ? <span>{this.props.store.navigation.dictionary.GoToCheckout}</span>
                                                                : <span>Låst: Utcheckning pågår av en annan användare</span>
                                                            : orderStore.activeOrder.OrderStatusId === 1
                                                                ? <span>{this.props.store.navigation.dictionary.GoToCheckout}</span>
                                                                : <span>Redan utchecked</span>
                                                        }


                                                    </button>

                                                </div>

                                            </div>
                                        </div>

                                        {/*{!orderStore.activeOrder*/}
                                        {/*    ? null*/}
                                        {/*    : <React.Fragment>*/}
                                        {/*        <div className="row">*/}

                                        {/*            <div className="col-6 pr-0">*/}
                                        {/*                {orderStore.activeOrder && !orderStore.activeOrder.ReadOnly*/}
                                        {/*                    ? <Switch>*/}
                                        {/*                        <Route path="*edit/:sku" render={({match}) =>*/}
                                        {/*                            <button*/}

                                        {/*                                onClick={() => {*/}
                                        {/*                                    this.props.store.navigation.openOrder();*/}
                                        {/*                                }}*/}
                                        {/*                                className="btn btn-sm btn-primary my-0">*/}
                                        {/*                            <span>*/}
                                        {/*                                Go to purchase order*/}
                                        {/*				</span>*/}
                                        {/*                            </button>*/}
                                        {/*                        }/>*/}

                                        {/*                        <Route>*/}
                                        {/*                            <React.Fragment>*/}
                                        {/*                                <button*/}
                                        {/*                                    disabled={(orderStore.activeOrder &&*/}
                                        {/*                                            orderStore.activeOrder.CheckoutStarted &&*/}
                                        {/*                                            orderStore.activeOrder.CheckoutUser !==*/}
                                        {/*                                            accountStore.UserId) ||*/}
                                        {/*                                        !orderStore.activeOrder.Valid ||*/}
                                        {/*                                        this.processingCheckout}*/}
                                        {/*                                    onClick={() => {*/}
                                        {/*                                        orderStore.activeOrder.checkoutStart().then(*/}
                                        {/*                                            (success) => {*/}
                                        {/*                                                this.props.store.navigation.openCheckout();*/}
                                        {/*                                                // this.props.store.navigation.closeChoose();*/}
                                        {/*                                                // this.props.store.navigation.openD2CCheckout();*/}
                                        {/*                                            });*/}

                                        {/*                                    }}*/}
                                        {/*                                    className="btn btn-sm btn-success mr-1 mb-1">*/}


                                        {/*                                    {orderStore.activeOrder.CheckoutStarted*/}
                                        {/*                                        ? orderStore.activeOrder.CheckoutUser ===*/}
                                        {/*                                        accountStore.UserId*/}
                                        {/*                                            ? <span>Fortsätt checka ut</span>*/}
                                        {/*                                            : <span>Låst: Utcheckning pågår av en annan användare</span>*/}
                                        {/*                                        : orderStore.activeOrder.OrderStatusId === 1*/}
                                        {/*                                            ? <span>Gå till utcheckning</span>*/}
                                        {/*                                            : <span>Redan utchecked</span>*/}
                                        {/*                                    }*/}


                                        {/*                                </button>*/}
                                        {/*                                {orderStore.activeOrder.CheckoutStarted &&*/}
                                        {/*                                orderStore.activeOrder.CheckoutUser === accountStore.UserId*/}
                                        {/*                                    ? <button*/}
                                        {/*                                        className="btn btn-sm btn-secondary mb-1"*/}
                                        {/*                                        onClick={(e) => {*/}
                                        {/*                                            orderStore.activeOrder.checkoutCancel()*/}
                                        {/*                                        }}>Avbryt</button>*/}
                                        {/*                                    :*/}
                                        {/*                                    <button*/}
                                        {/*                                        className="btn btn-sm btn-secondary mb-1"*/}
                                        {/*                                        onClick={(e) => {*/}
                                        {/*                                            navigationStore.closeToolbar();*/}
                                        {/*                                        }}>Stäng</button>*/}

                                        {/*                                }*/}
                                        {/*                            </React.Fragment>*/}

                                        {/*                        </Route>*/}
                                        {/*                    </Switch>*/}
                                        {/*                    : null}*/}
                                        {/*            </div>*/}

                                        {/*            <div className="col-6 text-right">*/}
                                        {/*                Varor (ex moms): {orderStore.activeOrder.Updating*/}
                                        {/*                ? <Spinner/>*/}
                                        {/*                : <strong>{orderStore.activeOrder.SubTotalFormatted + " " + orderStore.activeOrder.Currency}</strong>}*/}
                                        {/*                {(orderStore.activeOrder.FreeShippingInfo !== "")*/}
                                        {/*                    ? orderStore.activeOrder.Updating*/}
                                        {/*                        ? <Spinner/>*/}
                                        {/*                        : <span class={"freeshipping-info"}><br/>*/}
                                        {/*                            {parseFloat(orderStore.activeOrder.FreeShippingInfo) > 0*/}
                                        {/*                                ? <text>{orderStore.activeOrder.FreeShippingInfo} {orderStore.activeOrder.Currency} kvar till fri frakt</text>*/}
                                        {/*                                : <text>Fri frakt uppnådd</text>*/}
                                        {/*                            }*/}
                                        {/*                        </span>*/}
                                        {/*                    : null*/}
                                        {/*                }*/}
                                        {/*                <br/>Frakt (ex moms): {orderStore.activeOrder.Updating*/}
                                        {/*                ? <Spinner/>*/}
                                        {/*                : <strong>{orderStore.activeOrder.ShippingTotalExTaxFormatted + " " + orderStore.activeOrder.Currency}</strong>}*/}
                                        {/*                <br/>Moms: {orderStore.activeOrder.Updating*/}
                                        {/*                ? <Spinner/>*/}
                                        {/*                : orderStore.activeOrder.TaxTotalFormatted + " " + orderStore.activeOrder.Currency}*/}
                                        {/*                <br/>Att betala: {orderStore.activeOrder.Updating*/}
                                        {/*                ? <Spinner/>*/}
                                        {/*                : orderStore.activeOrder.OrderTotalFormatted + " " + orderStore.activeOrder.Currency}*/}


                                        {/*            </div>*/}

                                        {/*        </div>*/}
                                        {/*    </React.Fragment>*/}
                                        {/*}*/}

                                    </div>

                                }
                            </div>
                        </div>
                    </ToolbarSection>
                </ToolbarDropdown>

        );
    }
}


export default withRouter(PurchaseOrderView);